<template>

    <div class="py-6 md-py-3">
        <div class="progress-bar">

            <div class="progress-bar-progress" :style="{width: progress+'%'}"></div>
            <div class="progress-bar-wrapper">

                <template v-for="(step,index) in formattedSteps">
                    <progress-step :key="index"
                                   :step="step"
                                   :style="{paddingLeft: width+'%'}"
                                   @request-step="changeStep"></progress-step>
                </template>

            </div>

        </div><!-- END REGISTRATION SCREEN -->

        <div class="progress-bar-responsive m-top-3">
            <div class="c-dark-grey">Step {{ active + 1 }} out of {{ totalSteps }}</div>
            <div v-if="activeStepName" class="mt-1 c-charcoal">{{ activeStepName }}</div>
        </div>

    </div>

</template>

<script>

    import ProgressStep from '@/components/donations/ProgressStep';
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'ProgressBar',
        components: {
            ProgressStep
        },

        props: {
            active: {
                type: Number,
                required: true
            },
            steps: {
                type: Array,
                required: true
            }
        },

        computed: {
            totalSteps() {
                return this.steps.length;
            },
            /**
             * Returns percentage representation of the steps progress - Completed/Total
             * @returns {number}
             */
            progress() {
                if (this.active === 0 || !this.totalSteps) return 0;
                if (this.active === (this.totalSteps - 1)) return 100;
                return (this.active + 1) / (this.totalSteps + 1) * 100;
            },
            finalStep() {
                return (this.active === this.steps.length);
            },
            /**
             * Formatted steps
             */
            formattedSteps() {
                let array = [];
                for (let [index,step] of this.steps.entries()) {
                    let obj = {
                        index: index,
                        name: step.label,
                        active: index === this.active,
                        complete: (index < this.active || this.finalStep),
                        disabled: (index > this.active || this.finalStep)
                    };
                    array.push(obj);
                }
                return array;
            },
            width() {
                let length = this.totalSteps - 1;
                if (!length) return 0;
                return 100 / length;
            },
            activeStepName() {
                if (this.finalStep) return;
                return this.formattedSteps.find( item => item.active).name;
            },
        },

        methods: {
            changeStep($event) {
                if (!this.finalStep) {
                    this.$emit('change-step',$event);
                }
            }
        }
    }

</script>
